"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Select_component_exports = {};
__export(Select_component_exports, {
  Select: () => Select,
  SelectContext: () => SelectContext
});
module.exports = __toCommonJS(Select_component_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_react = __toESM(require("react"));
var import_react2 = require("@floating-ui/react");
var import_react3 = require("react");
var import_AngleUp = __toESM(require("@greatmindsorg/gmui-icons-lib/dist/AngleUp"));
var import_MenuBurger = __toESM(require("@greatmindsorg/gmui-icons-lib/dist/MenuBurger"));
var import_AngleDown = __toESM(require("@greatmindsorg/gmui-icons-lib/dist/AngleDown"));
var import_useViewport = require("../../utils/useViewport/useViewport.hook");
var import_baseTheme = require("../../baseTheme");
var import_clsx = __toESM(require("clsx"));
var import_SelectButton = require("./SelectButton.component");
var import_HelperText = __toESM(require("../HelperText/HelperText.component"));
var import_Label = require("../Label/Label.component");
var import_SimpleSelectButton = require("./SimpleSelectButton.component");
var import_SelectDropdown = require("./SelectDropdown.component");
var import_CustomButtonWrapper = require("./CustomButtonWrapper.component");
var import_CreateSelectContext = require("./CreateSelectContext.component");
const SelectContext = (0, import_react3.createContext)({});
function useSelectState(defaultIndex, children, placeholder) {
  const initialSelectedIndex = Array.isArray(children) ? children.findIndex(
    (child) => import_react.default.isValidElement(child) && // Check if the child is a valid React element
    Object.values(child.props).some(
      (prop) => typeof prop === "string" && prop === placeholder
      // Check if any prop matches the placeholder
    )
  ) : null;
  const isDefaultChild = typeof defaultIndex === "number" && Array.isArray(children) && defaultIndex >= 0 && defaultIndex < children.length ? children[defaultIndex] : null;
  const checkDefaultChild = (isDefaultChild == null ? void 0 : isDefaultChild.props) !== void 0 ? isDefaultChild.props.children : isDefaultChild;
  const initialSelectedOption = initialSelectedIndex !== null && initialSelectedIndex >= 0 ? children[initialSelectedIndex] : checkDefaultChild;
  const [isOpen, setIsOpen] = (0, import_react3.useState)(false);
  const [activeIndex, setActiveIndex] = (0, import_react3.useState)(null);
  const [selectedIndex, setSelectedIndex] = (0, import_react3.useState)(
    initialSelectedIndex !== null && initialSelectedIndex >= 0 ? initialSelectedIndex : defaultIndex
    // Otherwise, use the default index
  );
  const [selectedOption, setSelectedOption] = (0, import_react3.useState)(initialSelectedOption);
  return {
    isOpen,
    setIsOpen,
    activeIndex,
    setActiveIndex,
    selectedIndex,
    setSelectedIndex,
    selectedOption,
    setSelectedOption,
    checkDefaultChild,
    initialSelectedIndex,
    initialSelectedOption
  };
}
const Select = ({
  id = "default-id",
  defaultIndex,
  children,
  responsiveLogo,
  floatingMargin,
  dropdownPosition = "bottom",
  singleSelect,
  simpleSelect,
  placeholder = "Select Option",
  selectButtonSize = "medium",
  disabled = false,
  validationError,
  border = true,
  helperText,
  labelProps,
  labelPosition = "top",
  labelText,
  showPlusIcon = true,
  customSelect,
  customButton,
  matchButtonWidth,
  optionsContainerStyle,
  toggleButtonClassName,
  dropdownWidthPercent,
  testButtonWidth,
  onOpenStateChange,
  visiblyHiddenLabel = false,
  showHamburgerMenu = false
}) => {
  var _a, _b, _c;
  const {
    isOpen,
    setIsOpen,
    activeIndex,
    setActiveIndex,
    selectedIndex,
    setSelectedIndex,
    selectedOption,
    setSelectedOption,
    checkDefaultChild,
    initialSelectedIndex,
    initialSelectedOption
  } = useSelectState(defaultIndex, children, placeholder);
  const { width } = (0, import_useViewport.useViewport)();
  const [label, setLabel] = (0, import_react3.useState)("");
  const isFirstRender = (0, import_react3.useRef)(true);
  const moreThanOneChildren = Array.isArray(children) && children.length > 1;
  const labelRef = (0, import_react3.useRef)(null);
  const breakpointMdScreen = parseInt(import_baseTheme.baseTheme.theme.screens["md"], 10);
  const adjustPlacement = width < breakpointMdScreen ? `${dropdownPosition}-end` : `${dropdownPosition}-start`;
  const fallbackPlacements = [
    dropdownPosition,
    `${dropdownPosition}-start`,
    `${dropdownPosition}-end`
  ];
  const { refs, floatingStyles, context } = (0, import_react2.useFloating)({
    placement: adjustPlacement,
    open: isOpen,
    onOpenChange: (open) => {
      setIsOpen(open);
    },
    whileElementsMounted: import_react2.autoUpdate,
    middleware: [
      (0, import_react2.flip)({ fallbackPlacements }),
      (0, import_react2.size)({
        apply({ elements, availableHeight, availableWidth }) {
          Object.assign(elements.floating.style, {
            maxHeight: singleSelect || simpleSelect || customSelect ? "268px" : `${availableHeight}px`,
            maxWidth: `${availableWidth}px`
          });
        },
        padding: 10
      })
    ]
  });
  const elementsRef = (0, import_react3.useRef)([]);
  const labelsRef = (0, import_react3.useRef)([]);
  const modifiedFloatingStyles = __spreadValues(__spreadValues({}, helperText || validationError ? {} : floatingStyles), floatingMargin);
  const handleSelect = (0, import_react3.useCallback)((index, child) => {
    setSelectedIndex(index);
    setIsOpen(false);
    if (index !== null) {
      setSelectedOption(child);
    }
  }, []);
  function handleTypeaheadMatch(index) {
    if (isOpen) {
      setActiveIndex(index);
    } else {
      handleSelect(index);
    }
  }
  const listNav = (0, import_react2.useListNavigation)(context, {
    listRef: elementsRef,
    activeIndex,
    selectedIndex,
    onNavigate: setActiveIndex,
    loop: true,
    focusItemOnHover: false
  });
  const typeahead = (0, import_react2.useTypeahead)(context, {
    listRef: labelsRef,
    activeIndex,
    selectedIndex,
    onMatch: handleTypeaheadMatch
  });
  const click = (0, import_react2.useClick)(context);
  const dismiss = (0, import_react2.useDismiss)(context, {});
  const role = (0, import_react2.useRole)(context, { role: moreThanOneChildren ? "listbox" : "label" });
  const { getReferenceProps, getFloatingProps, getItemProps } = (0, import_react2.useInteractions)([
    listNav,
    typeahead,
    click,
    dismiss,
    role
  ]);
  const selectContext = (0, import_react3.useMemo)(
    () => (0, import_CreateSelectContext.createSelectContext)(
      activeIndex,
      selectedIndex,
      getItemProps,
      handleSelect,
      selectedOption,
      defaultIndex,
      setLabel,
      moreThanOneChildren,
      singleSelect,
      simpleSelect,
      customSelect
    ),
    [
      activeIndex,
      defaultIndex,
      selectedIndex,
      getItemProps,
      handleSelect,
      setLabel,
      moreThanOneChildren,
      singleSelect,
      simpleSelect,
      customSelect
    ]
  );
  const renderButtonContent = () => {
    if (selectedOption) {
      if (width <= breakpointMdScreen && responsiveLogo) {
        return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
          "span",
          __spreadProps(__spreadValues({}, moreThanOneChildren && { role: "button" }), {
            "aria-label": label,
            "data-testid": "responsive-logo-container",
            children: (0, import_react3.isValidElement)(selectedOption) && selectedOption.props.children[0]
          })
        );
      }
      if ((0, import_react3.isValidElement)(selectedOption)) {
        if (showHamburgerMenu) {
          return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_MenuBurger.default, { title: "Hamburger menu", iconSize: "m", "aria-label": "Menu" });
        } else return selectedOption.props.children;
      }
      return placeholder;
    }
    return placeholder;
  };
  const onKeyDown = (e) => {
    if (e.key === "Tab") {
      setIsOpen(false);
      e.preventDefault();
    }
  };
  const onKeyUp = (e) => {
    if (e.key === "Escape") {
      setIsOpen(false);
      e.preventDefault();
    }
  };
  (0, import_react3.useEffect)(() => {
    const handleClickOutside = (event) => {
      if (refs.floating.current && !refs.floating.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    if (singleSelect) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    if (!isOpen) {
      setTimeout(() => {
        if (refs.reference.current && refs.reference.current instanceof HTMLButtonElement) {
          refs.reference.current.focus();
        }
      }, 10);
    }
    return () => {
      if (singleSelect) {
        document.removeEventListener("mousedown", handleClickOutside);
      }
    };
  }, [isOpen, singleSelect, refs.floating]);
  const labelId = `${id}-select-label-id`;
  const helperTextId = `${id}-select-helper-text-id`;
  const buttonId = `${id}-select-button-id`;
  const renderLabel = (labelId2, buttonId2) => {
    if ((singleSelect || simpleSelect || customSelect) && labelProps && labelText) {
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        "div",
        {
          "data-testId": "render-select-label-wrapper",
          className: (0, import_clsx.default)({
            "mb-1": labelPosition === "top",
            "mr-2 self-start": labelPosition === "left",
            "mt-4": labelPosition === "left" && selectButtonSize !== "small",
            "mt-1.5": labelPosition === "left" && selectButtonSize === "small",
            "gmui-visibly-hidden": visiblyHiddenLabel
          }),
          children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
            import_Label.Label,
            __spreadProps(__spreadValues({}, labelProps), {
              label: labelText,
              htmlFor: buttonId2,
              id: labelId2,
              dataTestId: "render-select-label",
              className: "gmui-font-style-body-compact text-[--color-content-interactive-label-text]"
            })
          )
        }
      );
    }
    return null;
  };
  const [announcement, setAnnouncement] = (0, import_react3.useState)("");
  (0, import_react3.useEffect)(() => {
    if (selectedOption) {
      const optionLabel = (0, import_react3.isValidElement)(selectedOption) ? selectedOption.props.children : selectedOption;
      setAnnouncement(`Selected ${optionLabel}`);
    }
  }, [selectedOption]);
  const buttonRef = (0, import_react3.useRef)(null);
  const [buttonWidth, setButtonWidth] = (0, import_react3.useState)(null);
  (0, import_react3.useEffect)(() => {
    if (testButtonWidth !== void 0) {
      setButtonWidth(testButtonWidth);
    } else if (singleSelect && (matchButtonWidth === void 0 || matchButtonWidth) && buttonRef.current) {
      const width2 = buttonRef.current.offsetWidth;
      setButtonWidth(width2);
    }
  }, [selectedOption, width, singleSelect, matchButtonWidth]);
  (0, import_react3.useEffect)(() => {
    if (initialSelectedIndex !== null && initialSelectedIndex > 0) {
      setSelectedIndex(initialSelectedIndex);
    } else {
      setSelectedIndex(defaultIndex);
    }
    setSelectedOption(initialSelectedOption);
  }, [
    children,
    defaultIndex,
    initialSelectedIndex,
    setSelectedIndex,
    setSelectedOption,
    checkDefaultChild,
    initialSelectedOption
  ]);
  (0, import_react3.useEffect)(() => {
    onOpenStateChange == null ? void 0 : onOpenStateChange(isOpen);
  }, [isOpen, onOpenStateChange]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, { children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(SelectContext.Provider, { value: selectContext, children: [
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      "span",
      {
        ref: labelRef,
        style: { visibility: "hidden", position: "absolute", whiteSpace: "nowrap" },
        children: labelText
      }
    ),
    labelProps && labelPosition === "top" && renderLabel(labelId, buttonId),
    /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(
      "div",
      {
        id,
        className: (0, import_clsx.default)({
          "flex flex-row items-center": labelPosition === "left"
        }),
        children: [
          labelProps && labelPosition === "left" && renderLabel(labelId, buttonId),
          customSelect && customButton && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
            import_CustomButtonWrapper.CustomButtonWrapper,
            {
              customButton,
              getReferenceProps,
              setIsOpen,
              isOpen,
              ref: refs.setReference
            }
          ),
          singleSelect && // Single select button
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", { className: "flex w-full flex-col items-start", children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", { className: "w-full", children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
              import_SelectButton.SelectButton,
              {
                isOpen,
                renderButtonContent,
                selectButtonSize,
                ref: (node) => {
                  refs.setReference(node);
                  buttonRef.current = node;
                },
                getReferenceProps,
                setIsOpen,
                disabled,
                validationError: !!validationError,
                border,
                id: buttonId,
                "aria-haspopup": "listbox",
                "aria-expanded": isOpen,
                showPlusIcon,
                as: "button",
                ariaLabelledBy: `${labelProps && labelText ? labelId : ""}${helperText ? ` ${helperTextId}` : ""} ${buttonId}`,
                className: toggleButtonClassName,
                labelTextLength: (_b = (_a = buttonRef == null ? void 0 : buttonRef.current) == null ? void 0 : _a.innerText) == null ? void 0 : _b.length,
                buttonWidth: (_c = buttonRef == null ? void 0 : buttonRef.current) == null ? void 0 : _c.clientWidth
              }
            ) }),
            !isOpen && (validationError || helperText) && /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", { className: (0, import_clsx.default)("ml-2"), children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
              import_HelperText.default,
              {
                validationError,
                helperText,
                id: helperTextId,
                isInvalid: !!validationError
              }
            ) })
          ] }),
          simpleSelect && // Simple select button
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
            import_SimpleSelectButton.SimpleSelectButton,
            {
              placeholder,
              getReferenceProps,
              id: "label-select-button-id",
              "aria-haspopup": "listbox",
              "aria-expanded": isOpen,
              ref: refs.setReference,
              as: "button"
            }
          ),
          !singleSelect && !simpleSelect && !customSelect && // Default select button
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(
            "button",
            __spreadProps(__spreadValues({
              className: (0, import_clsx.default)([
                "select-button-no-border gmui-button-select flex h-9 items-center gap-2 px-4 text-base font-semibold text-[--color-content-interactive-label-text] outline-none hover:cursor-pointer focus:outline focus:outline-[--color-border-interactive-focus]",
                toggleButtonClassName
              ]),
              "data-testid": "select-testid",
              "aria-label": showHamburgerMenu ? "Menu" : "Selected",
              type: "button",
              ref: refs.setReference,
              tabIndex: 0
            }, getReferenceProps()), {
              children: [
                renderButtonContent(),
                moreThanOneChildren && showHamburgerMenu === false ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)("span", { className: "ml-1 h-4 w-4", children: isOpen ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
                  import_AngleUp.default,
                  {
                    title: "select close icon",
                    "aria-hidden": true,
                    iconSize: "inherit"
                  }
                ) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
                  import_AngleDown.default,
                  {
                    "aria-hidden": true,
                    title: "select open icon",
                    iconSize: "inherit"
                  }
                ) }) : null
              ]
            })
          )
        ]
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      import_SelectDropdown.SelectDropdown,
      {
        context,
        isOpen,
        onKeyDown,
        refs,
        modifiedFloatingStyles,
        singleSelect,
        simpleSelect,
        getFloatingProps,
        elementsRef,
        labelsRef,
        onKeyUp,
        customSelect,
        buttonWidth: singleSelect && (matchButtonWidth || buttonWidth) ? buttonWidth : null,
        dropdownWidthPercent,
        matchButtonWidth,
        optionsContainerStyle,
        children
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      "div",
      {
        "aria-live": "polite",
        "aria-atomic": "true",
        style: { position: "absolute", left: "-9999px" },
        children: announcement
      }
    )
  ] }) });
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Select,
  SelectContext
});
//# sourceMappingURL=Select.component.js.map